/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { PowerCalendarDay, PowerCalendarPublicAPI, PowerCalendarWeek } from 'ember-power-calendar';
import { SEGMENT_MEMBERSHIP_RELEASE_TIMESTAMP } from 'cio/utils/metrics/segment-membership';
import moment from 'moment-timezone';

interface SegmentMembershipDatePickerDaysArgs {
  day: PowerCalendarDay;
  calendar: PowerCalendarPublicAPI;
  weeks: PowerCalendarWeek[];
  minDate: moment.Moment;
  maxDate: moment.Moment;
}

export default class SegmentMembershipDatePickerDays extends Component<SegmentMembershipDatePickerDaysArgs> {
  segmentMembershipReleaseDate = SEGMENT_MEMBERSHIP_RELEASE_TIMESTAMP;

  get isAfterMaxDate() {
    return this.args.day.moment?.isAfter(this.args.maxDate);
  }
}
